module.exports = __webpack_public_path__ + "media/images/favicon-d7f41086f432114c8ee65570fe247da9.png";